// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u2-0";